export class Procedure{
    id?:string = '';
    centerId?: string = '';
    code?: string = '';
    description?: string = '';
    codeType?:string = 'DRG';
}